// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__-BkTM","rootSmall":"AddTileButton_rootSmall__4qw1L"};